import React from 'react';
import { Link } from 'react-router-dom';
import { FirstStepSignupConfig } from '../../types/workshopFirstStepSignup';
import StepHelpButton from '../StepHelpButton';
import WorkshopFirstStepSignupCard from './WorkshopFirstStepSignupCard';
import { useLocale } from '../../context/LocaleContext';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopStepWorkSectionProps {
  meetingCode: string | null;
  canFacilitate?: boolean;
  initialFirstStepSignup?: FirstStepSignupConfig | null;
  viewerUserId?: string;
}

const WorkshopStepWorkSection: React.FC<WorkshopStepWorkSectionProps> = ({
  meetingCode,
  canFacilitate = false,
  initialFirstStepSignup = null,
  viewerUserId,
}) => {
  const { t } = useLocale();
  return (
    <>
      <section className={styles.zoomBlockFeatured}>
        <div className={styles.workshopHelpRow}>
          <Link to="/saa?tab=steps" className={styles.stepWorkButton}>
            {t('workshop.2026.step_work.cta')}
          </Link>
          <StepHelpButton stepKey="workshop" />
        </div>
      </section>
      {meetingCode && (
        <WorkshopFirstStepSignupCard
          meetingCode={meetingCode}
          canFacilitate={canFacilitate}
          initialSignup={initialFirstStepSignup}
          viewerUserId={viewerUserId}
        />
      )}
    </>
  );
};

export default WorkshopStepWorkSection;
